"use strict";

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var fonts = tslib_1.__importStar(require("../fonts"));

exports.xxxlarge = {
  fontFamily: fonts.base,
  fontSize: 31,
  fontWeight: 600,
  lineHeight: 1.35
};
exports.xxlarge = {
  fontFamily: fonts.base,
  fontSize: 26,
  fontWeight: 600,
  lineHeight: 1.23
};
exports.xlarge = {
  fontFamily: fonts.base,
  fontSize: 22,
  fontWeight: 600,
  lineHeight: 1.5
};
exports.large = {
  fontFamily: fonts.base,
  fontSize: 18,
  lineHeight: 1.5
};
exports.base = {
  fontFamily: fonts.base,
  fontSize: 15,
  lineHeight: 1.53
};
exports.small = {
  fontFamily: fonts.base,
  fontSize: 13,
  lineHeight: 1.54
};
exports.xsmall = {
  fontFamily: fonts.base,
  fontSize: 11,
  lineHeight: 1.55
};